export default __webpack_public_path__ + "static/media/purpes 5.ad8483b0.png";